'use strict';

import { authState } from './appState.js';
import { ajaxWrapNew, ResponseDispatcher, CommandRegistry } from './ajaxWrapNew.js';
import { VarMgr } from './VarMgr.js';
import { datetimeToDate, timeToView } from './Times.js';
import { connMTUpdater } from './connMTUpdater.js';
import { jconnanimInit, jconnanimUpdate } from './connanim.js';
import { lmAppStorage } from './lmAppStorage.js';
import { sleep } from './asyncTools.js';
import { autoSyncer } from './autoSyncer.js';
import { getJsonData, getAnimScript } from './dataHelpers.js';

const connectCommands = {
    createMiracles: (payload) => {
        if (!payload) return;
        createMiracles(payload.items, payload.randWelcome, payload.createFallingStar, payload.id);
    },
};


var miracleAnimRunning = false;

const connectScenes = {
    connectOff: null,
    connectOn: null,
    connectB2On: null,
    disconnectOff: null,
    disconnectOn: null
};
const connectAnimations = {
    connect: null,
    star: null,
    addscene: null,
    miracle: null
};


function goAjaxConnection(on, timeId, timeTime, ext) {
    ajaxWrapNew({
        method: 'POST',
        data: $.extend({
            ajax: 1,
            action: 'connection',
            on: on ? 1 : 0,
            id: $('.connectTx').data('id'),
            cnfid: $('.connectTx').data('cnfid'),
            timeId: timeId ?? '',
            timeTime: timeTime ?? '',
            logged: authState.getColdState().loggedIn ? 1 : 0
        }, ext || {}),
        success: function (data) {
            ResponseDispatcher.handle(data, 'connection');
        },
        dataType: 'json'
    });
}

function transformPageToConnected() {
    $('footer').animate({
        opacity: 0,
    }, 500, function () {
        $('body').addClass('pageIsConnected');

        $('.cnoff').css({
            opacity: 0
        }).animate({
            opacity: 1,
        }, 500, function () {
            $('body').addClass('pageIsConnected');
        });
    });
}

function transformPageToDisconnected() {
    $('.cnoff').animate({
        opacity: 0,
    }, 500, function () {
        $('footer').css({
            opacity: 0
        });
        $('body').removeClass('pageIsConnected');
        $('footer').animate({
            opacity: 1,
        }, 500, function () {

        });
    });

    $('.moreTx').animate({
        opacity: 0,
        height: 0
    }, 500, function () {
        $('.moreTx').css({
            display: 'none',
            height: ''
        });
    });
}

function goConnect() {
    $('.connectContainer').addClass('isConnect');
    transformPageToConnected();

    $('.jq-admin-connect').toggleClass('active', true);
    connectScenes.connectOff();
    connectScenes.connectOn();
    connectScenes.connectB2On();
}

function goDisconnect() {
    $('.jq-admin-connect').toggleClass('active', false);
    transformPageToDisconnected();

    connectScenes.disconnectOff();
    connectScenes.disconnectOn();
}

function initConnectPage(isConnected, conf) {
    var $previewClicker;
    var thisConnectIsConnected = isConnected;
    var openChatAfterConnect = VarMgr.get('openChatAfterConnect', false);

    CommandRegistry.registerCommands(connectCommands);

    // Paslēpjam connect pogu;
    if (conf.connect.off.animId) {
        const selector = '.sceneConnect';
        const anim = createAnim(selector, conf.connect.off.animId, conf.connect.off.animData, function () {
            $(selector).css({
                opacity: 0,

                transform: '',
                filter: ''
            });
            connectAnimations.connect.togglePause(true);
        });

        connectScenes.connectOff = function () {
            setTimeout(function () {
                anim.playStart();
            }, conf.connect.off.delay);
        };
    } else {
        connectScenes.connectOff = function () {
            $('.sceneConnect')
                .stop(true, false)
                .delay(conf.connect.off.delay)
                .animate({
                    opacity: 0
                }, conf.connect.off.speed, function () {
                    connectAnimations.connect.togglePause(true);
                });
        };
    }

    // Parādam zvaigzni
    if (conf.connect.on.animId) {
        let anim,
            selector = '.sceneStar',
            onStop = function () {
                $(selector).css({
                    opacity: 1,
                    transform: '',
                    filter: ''
                });
                if ($('.cht2fld').length) {
                    $('.cht2fld').css('display', '');
                    if (openChatAfterConnect) {
                        openChatAfterConnect = false;
                        $('.cht2fld').click();
                    }
                }
            };

        if (!conf.connect.on.startNow) {
            onStop = function () {
                connectAnimations.star.playStart();
                $(selector).css({
                    opacity: 1,
                    transform: '',
                    filter: ''
                });

                if (VarMgr.get('PAUSE_STAR', false)) {
                    connectAnimations.star.togglePause(true);
                }
            };
        }

        anim = createAnim(selector, conf.connect.on.animId, conf.connect.on.animData, onStop);

        connectScenes.connectOn = function () {
            if (conf.connect.on.startNow) {
                connectAnimations.star.playStart();

                if (VarMgr.get('PAUSE_STAR', false)) {
                    connectAnimations.star.togglePause(true);
                }
            }
            setTimeout(function () {
                anim.playStart();
            }, conf.connect.on.delay);
        };
    } else {
        connectScenes.connectOn = function () {
            if (conf.connect.on.startNow) {
                connectAnimations.star.playStart();

                if (VarMgr.get('PAUSE_STAR', false)) {
                    connectAnimations.star.togglePause(true);
                }
            }
            $('.sceneStar')
                .stop(true, false)
                .delay(conf.connect.on.delay)
                .animate({
                    opacity: 1
                }, conf.connect.on.speed, function () {
                    if (!conf.connect.on.startNow) {
                        connectAnimations.star.playStart();

                        if (VarMgr.get('PAUSE_STAR', false)) {
                            connectAnimations.star.togglePause(true);
                        }
                    }

                    if ($('.cht2fld').length) {
                        $('.cht2fld').css('display', '');
                        if (openChatAfterConnect) {
                            openChatAfterConnect = false;
                            $('.cht2fld').click();
                        }
                    }
                });
        };
    }

    // Parādam starpanimāciju
    if (conf.addsceneScript) {
        if (conf.connect.b2on.animId) {
            let anim,
                selector = '.sceneToStar',
                onStop = function () {
                    /*
                    $( selector ).css({
                        opacity: 1,
                        transform: '',
                        filter: ''
                    });
                    */
                };

            if (!conf.connect.b2on.startNow) {
                onStop = function () {
                    connectAnimations.addscene.playStart();
                    /*
                    $( selector ).css({
                        opacity: 1,
                        transform: '',
                        filter: ''
                    });
                    */
                };
            }

            anim = createAnim(selector, conf.connect.b2on.animId, conf.connect.b2on.animData, onStop);

            connectScenes.connectB2On = function () {
                if (conf.connect.b2on.startNow) {
                    connectAnimations.addscene.playStart();
                }
                setTimeout(function () {
                    anim.playStart();
                }, conf.connect.b2on.delay);
            };
        } else {
            connectScenes.connectB2On = function () {
                if (conf.connect.b2on.startNow) {
                    connectAnimations.addscene.playStart();
                }
                $('.sceneToStar')
                    .stop(true, false)
                    .delay(conf.connect.b2on.delay)
                    .animate({
                        opacity: 1
                    }, conf.connect.b2on.speed, function () {
                        if (!conf.connect.b2on.startNow) {
                            connectAnimations.addscene.playStart();
                        }
                    });
            };
        }
    } else {
        connectScenes.connectB2On = function () { };
    }

    // Paslēpjam zvaigzni
    if (conf.disconnect.off.animId) {
        let anim,
            selector = '.sceneStar',
            onStop = function () {
                $(selector).css({
                    opacity: 0,
                    transform: '',
                    filter: ''
                });
            };

        if (!conf.disconnect.off.stopNow) {
            onStop = function () {
                connectAnimations.star.playStop(true);
                $(selector).css({
                    opacity: 0,
                    transform: '',
                    filter: ''
                });
            };
        }

        anim = createAnim(selector, conf.disconnect.off.animId, conf.disconnect.off.animData, onStop);

        connectScenes.disconnectOff = function () {
            if ($('.cht2fld').length) {
                $('.cht2fld').css('display', 'none');
            }
            if (conf.disconnect.off.stopNow) {
                connectAnimations.star.playStop(true);
            }
            setTimeout(function () {
                anim.playStart();
            }, conf.disconnect.off.delay);
        };
    } else {
        connectScenes.disconnectOff = function () {
            if ($('.cht2fld').length) {
                $('.cht2fld').css('display', 'none');
            }
            if (conf.disconnect.off.stopNow) {
                connectAnimations.star.playStop(true);
            }
            $('.sceneStar')
                .stop(true, false)
                .delay(conf.disconnect.off.delay)
                .animate({
                    opacity: 0
                }, conf.disconnect.off.speed, function () {
                    if (!conf.disconnect.off.stopNow) {
                        connectAnimations.star.playStop(true);
                    }
                });
        };
    }

    // Parādam connect pogu;
    if (conf.disconnect.on.animId) {
        let anim,
            selector = '.sceneConnect';

        anim = createAnim(selector, conf.disconnect.on.animId, conf.disconnect.on.animData, function () {
            $(selector).css({
                opacity: 1,
                transform: '',
                filter: ''
            });
            $('.connectContainer').removeClass('isConnect');
        });

        connectScenes.disconnectOn = function () {
            setTimeout(function () {
                connectAnimations.connect.togglePause(false);
                anim.playStart();
            }, conf.disconnect.on.delay);
        };
    } else {
        connectScenes.disconnectOn = function () {
            connectAnimations.connect.togglePause(false);
            $('.sceneConnect')
                .stop(true, false)
                .delay(conf.disconnect.on.delay)
                .animate({
                    opacity: 1
                }, conf.disconnect.on.speed, function () {
                    $('.connectContainer').removeClass('isConnect');
                    transformPageToDisconnected();
                });
        };
    }

    if (typeof modAnimationRun === 'undefined') {
        return;
    }
    connectAnimations.connect = new modAnimationRun({
        groups: conf.connectScript.groups,
        animations: conf.connectScript.animations,

        animationContainer: '.connectAnimation',

        onAnimationStart: function (anim) {
            anim.options.onAnimationStart = null;
            if (conf.clickField.active) {
                $('.sceneConnect').find('.connectAnimation').each(function () {
                    var animEl = $(this).find('.animation-element[data-animid="' + conf.clickField.field.animId + '"]').get(0);
                    if (!animEl) {
                        return;
                    }

                    $previewClicker = $('<div class="like-animation-element connectClick"></div>').css({
                        position: 'absolute',
                        zIndex: 5,
                        placeSelf: 'center',
                        width: animEl.style.width,
                        height: animEl.style.height,
                        borderRadius: conf.clickField.radius
                    });

                    $(this).append($previewClicker);
                });
            }
        }
    }, $('.sceneConnect').get(0));

    connectAnimations.star = new modAnimationRun({
        autoplay: isConnected ? true : false,
        prepare: true,
        groups: conf.starScript.groups,
        animations: conf.starScript.animations,

        animationContainer: '.starAnimation'
    }, $('.sceneStar').get(0));


    if (conf.miracleScript) {
        $.each(conf.miracleScript.groups, function (i, v) {
            if (conf.miracleScript.groups[i].items) {
                $.each(conf.miracleScript.groups[i].items, function (i2, v2) {
                    conf.miracleScript.groups[i].items[i2].multiply = true;
                    //conf.miracleScript.groups[i].items[i2].randomizeStart = {translate:{x:[true,-10000,10000],y:[true,-10000,10000]}};
                });
            }
        });

        connectAnimations.miracle = new modAnimationRun({
            autoplay: false,
            prepare: true,
            groups: conf.miracleScript.groups,
            animations: conf.miracleScript.animations,

            animationContainer: '.miracleAnimation'
        }, $('.sceneMiracle').get(0));
    }


    if (conf.addsceneScript) {
        connectAnimations.addscene = new modAnimationRun({
            autoplay: false,
            prepare: true,
            groups: conf.addsceneScript.groups,
            animations: conf.addsceneScript.animations,

            animationContainer: '.addsceneAnimation'
        }, $('.sceneToStar').get(0));
    }

    if (isConnected) {
        if (VarMgr.get('PAUSE_STAR', false)) {
            connectAnimations.star.togglePause(true);
        }
        connectAnimations.connect.togglePause(true);
    }

    /* goTogglePause = function (paused) {
        connectAnimations.star.togglePause(paused);
    }; */
    addEventListener('star:togglePause', function (e) {
        // @ts-ignore
        connectAnimations.star.togglePause(e?.detail?.paused);
    });
    addEventListener('conn:showConnect', function () {
        showConnect();
    });

    addStatCounterGlobal($('.connectTx').data('id'), $('.connectTx').data('cnfid'), async (data) => {
        if (typeof window['statsUpdaterFinish'] == 'function') {
            window['statsUpdaterFinish'](data);
        }
    });

    var $connMT = $('.connMT');
    var connUpdater = new connMTUpdater({
        selector: '.connMT'
    });
    //window['connUpdater'] = connUpdater;

    var timer, timerActive = false;
    var clearTimer = function () {
        timerActive = false;
        clearInterval(timer);
    };
    var createTimer = function () {
        clearTimer();

        const start = Math.floor(new Date().getTime() / 1000);
        const ttl = datetimeToDate($('.timerSelect').data('ttl'));
        const now = datetimeToDate($('.timerSelect').data('now'));
        const nowReal = $('.timerSelect').data('nowReal') || new Date();
        const added = datetimeToDate($('.timerSelect').data('added'));
        const isTimeless = $('.timerSelect').data('istimeless') == 1;
        if (!now || !added) {
            return;
        }
        if (!ttl && !isTimeless) {
            return;
        }

        const timeDiff = start - Math.floor(now.getTime() / 1000);
        const startDiff = ttl ? Math.floor((ttl.getTime() - now.getTime()) / 1000) + 1 : 0;
        const startAdded = Math.floor(added.getTime() / 1000) + timeDiff;
        if (startDiff <= 0 && !isTimeless) {
            goAjaxConnection(false);
            return;
        }

        var nowLeft = startDiff,
            $timer = $('.timerSelect');
        var timerFunc;

        if (isTimeless) {
            timerFunc = () => {
                if (!timerActive) {
                    return;
                }
                nowLeft = Math.floor(new Date().getTime() / 1000) - startAdded;

                $timer.text(timeToView(nowLeft));
            };
        } else {
            timerFunc = () => {
                if (!timerActive) {
                    return;
                }
                nowLeft = startDiff - (Math.floor(new Date().getTime() / 1000) - start) - 1;

                if (nowLeft <= 0) {
                    // ja laiks beidzas - disconnect;
                    clearInterval(timer);
                    goAjaxConnection(false);
                }

                let daysLeft = nowLeft > 86400 ? Math.floor(nowLeft / 86400) : 0;
                $timer.text((daysLeft >= 1 ? daysLeft + 'd ' : '') + (new Date(nowLeft * 1000).toISOString().slice(11, 19)));
            };
        }

        clearInterval(timer);
        timerActive = true;
        timer = setInterval(timerFunc, 1000);
        timerFunc();
    };


    const connectionCommands = {
        connectionStatus: function(connection) {
            if (!connection) return;

            if (connection.status === 'connected') {
                clearTimer();
                if (!thisConnectIsConnected) {
                    goConnect();
                }
                thisConnectIsConnected = true;
                $('.energyFieldSwitchContainer').show();

                const time = connection.ttlKey == 'timeless' ? '' : connection.connectTime;

                $('.connectTx').data('id', connection.connectId);
                $('.timerField').find('.active').removeClass('active');

                if (connection.ttlKey == 'timeless') {
                    $('.timerField').find('.timerSet[data-id="timeless"]').addClass('active');
                    $('.timerSelect')
                        //.text(connection.timeText)
                        .data('istimeless', '1')
                        .data('ttl', '')
                        .data('now', connection.now)
                        .data('nowReal', new Date())
                        .data('added', connection.added);

                    $('.timeless-date').html('<br>' + (connection.currentSelectedTimerFrom || ''));

                    createTimer();
                } else {
                    $('.timerField').find('.timerSet[data-time="' + connection.ttlKey + '"]').addClass('active');
                    $('.timerSelect')
                        //.text('')
                        .data('istimeless', '')
                        .data('ttl', connection.ttl)
                        .data('now', connection.now)
                        .data('nowReal', new Date())
                        .data('added', connection.added);
                    createTimer();

                    $('.timeless-date').html('');
                }

                jconnanimUpdate(1, connection.ttlKey == 'timeless' ? 1 : 0, connection.ttlKey);
            } else if (connection.status === 'disconnected') {
                if (thisConnectIsConnected) {
                    goDisconnect();
                }
                thisConnectIsConnected = false;
                $('.energyFieldSwitchContainer').hide();

                clearTimer();
                jconnanimUpdate(0, 0, null);
            }
        },
        connectionCounter: function(counterData) {
            $('.connM0').text(counterData.counter);
            $('.connM1').text(counterData.counterM1);

            if ($connMT.data('cnt') != counterData.counter) {
                $connMT.data('cnt', counterData.counter);
                connUpdater.update(counterData.connMT, counterData.counter, counterData.counterTT);
            }
            //statsUpdater.create();
        }
    };
    // reģistrējam kā globālo, lai varētu izsaukt arī no citiem response handleriem, un autoSync;
    CommandRegistry.registerCommands(connectionCommands);


    $('body').on('click', '.like-animation-element', function (event) {
        event.preventDefault();

        goAjaxConnection(true);
    });

    $('.addscroll').on('click', function (event) {
        lmAppStorage.history.set('addscroll' + $(this).data('ky'), $(window).scrollTop());
    });


    $('body').on('click', 'button[data-action="connect-login"]', function (event) {
        event.preventDefault();

        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'connection-login',
                addback: $(this).data('addback'),
                loginlink: $(this).data('loginlink'),
                ttlkey: $(this).data('ttlkey'),
                id: $('.connectTx').data('id')
            },
            success: function (data) {
                ResponseDispatcher.handle(data);
            },
            dataType: 'json'
        });
    });

    $('body').on('click', '.energyFieldSwitch', function (event) {
        event.preventDefault();

        if ($('.energyFieldSwitch').hasClass('switching')) {
            return;
        }
        $('.energyFieldSwitch').addClass('switching');

        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'switch-energy-field',
                fromConnect: 1
            },
            success: function (data) {
                ResponseDispatcher.handle(data);


                if (data.ok) {
                    const $icon = $('.switchIcon');
                    if (data.newScene && data.newScene != $icon.data('currentscene')) {
                        $icon.attr('data-currentscene', data.newScene).data('currentscene', data.newScene);
                    }

                    dispatchEvent(new CustomEvent('energySwitchTo', {
                        detail: {
                            newScene: data.newScene,
                            onShowStart: () => {
                                $('.energyFieldSwitch')
                                    .attr('title', data.full || '')
                                    .find('.title').html(data.sm || '');
                            },
                            callback: () => {
                                // Callback after the scene switch completes
                                $('.energyFieldSwitch').removeClass('switching');
                            }
                        }
                    }));
                    // @ts-ignore
                    /* if (typeof window.energySwitchTo === 'function') {
                        // @ts-ignore
                        window.energySwitchTo(data.newScene, function() {
                            $('.energyFieldSwitch')
                                .attr('title', data.full || '')
                                .find('.title').html(data.sm || '');
                        }).then(function() {
                            // Callback after the scene switch completes
                            $('.energyFieldSwitch').removeClass('switching');
                        });
                    } */
                }
            },
            dataType: 'json'
        });
    });

    $('body').on('click', '.connact[data-action="confirm"]', function (event) {
        event.preventDefault();

        goAjaxConnection(false, 0, '', $(this).data('dt'));
    });

    var timerSelectOpened = false;
    $('body').on('click.tmr', '.timerSelect', function (event) {
        event.stopPropagation();

        timerSelectOpened = !timerSelectOpened;
        $(this).parent().find('.timerField').toggle(timerSelectOpened).each(function () {
            if (timerSelectOpened) {
                $(this).after('<span class="overlayOutclicker"></span>');
            }
        });
    });
    $('body').on('click.tmr', '.timerSelectClone', function (event) {
        event.stopPropagation();

        if ($('.bABCMODE').length) {
            return;
        }

        if ($(this).parent().find('.timerField').length == 0) {
            $(this).wrap('<span class="timerFieldCloneContainer"></span>');
            $(this).after(
                $('.timerField').first().clone().addClass('isClone')
                    .find('.clockElement').remove().end()
            );
            jconnanimInit($('.jconnanim.v1').first().get(0));
        }

        timerSelectOpened = !timerSelectOpened;
        $(this).parent().find('.timerField').toggle(timerSelectOpened).each(function () {
            if (timerSelectOpened) {
                $(this).after('<span class="overlayOutclicker"></span>');
            }
        });
    });


    $('body').on('click.tmr', '.timerSet', function (event) {
        event.stopPropagation();

        timerSelectOpened = false;
        $('.timerField').hide();
        $('.overlayOutclicker').remove();
        goAjaxConnection($(this).data('id') != 'disconnect', $(this).data('id'), $(this).data('time'));
    });
    $('body').on('click.tmr', '.timerField', function (event) {
        event.stopPropagation();
    });

    $(window).on('jq-outclick.tmr', function (event) {
        if (timerSelectOpened) {
            timerSelectOpened = false;
            $('.timerField').hide();
            $('.overlayOutclicker').remove();
        }
    });


    if (isConnected) {
        createTimer();
    }
    //statsUpdater.create();
}

function createAnim(selector, animId, animData, onStop) {
    return new modAnimationRun({
        autoplay: false,
        groups: animData.groups,
        animations: {
            [animId]: {
                autoHide: false,
                defaultDisplay: 'block',
                elementMode: true,
                animdata: animData.animdata,
                element: $(selector).get(0),
                width: $(selector).width(),
                height: $(selector).height()
            }
        },

        animationContainer: $(selector).parent().get(0),
        onStop: onStop
    }, $(selector).get(0));
}

function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function createMiracles(miracles, randWelcome, createFallingStar, cht2ItemId = 0) {
    if (miracleAnimRunning) {
        return;
    }
    miracleAnimRunning = true;

    const el = disableClicking(true);

    $('.cht2fld').css('display', 'none');


    const ina = typeof window['isInAdmin'] != 'undefined' ? window['isInAdmin'] : false;
    var list = [0];
    let maxRandom = miracles.maxTime - (miracles.count * miracles.mmdelay);
    let leftRandom = maxRandom;
    let usedRandom = 0;
    for (let i = 1; i <= miracles.count - 1; ++i) {
        let randomDelay = getRndInteger(miracles.mmdelay, leftRandom);
        usedRandom += randomDelay;
        leftRandom = miracles.maxTime - usedRandom - ((miracles.count - i - 1) * miracles.mmdelay);

        list.push(randomDelay);
    }

    setTimeout(function () {
        $('.cht2fld').css('display', 'none');

        let startTime = new Date();
        connectAnimations.miracle.onStop = function () {
            let endTime = new Date();
            // @ts-ignore
            let duration = endTime - startTime;
            miracleAnimRunning = false;

            if (randWelcome) {
                showRandWelcome(randWelcome);
            }
            if (createFallingStar) {
                createFallingStarAnimation(createFallingStar, cht2ItemId, true);
            }

            disableClicking(false, el, true);
            showConnect();
        };
        connectAnimations.miracle.playStart();
        $('.sceneMiracle').css({
            opacity: 1,
            transform: '',
            filter: ''
        });

        let timeout = 0;
        for (let i = 1; i < list.length; ++i) {
            timeout += list[i];
            setTimeout(function () {
                connectAnimations.miracle.animList['initial'].play();
            }, timeout);
        }
    }, miracles.delay);
}

async function createFallingStarAnimation(starScene, cht2ItemId = 0, runconfs = false, cbbefore = null, cbstop = null) {
    if (typeof window['scene_' + starScene] == 'undefined') {
        console.log('scene for falling star not found ' + starScene);
        return;
    }

    const $fallingAnimationContainer = $('.fallingAnimationContainer');

    var fallingStarScript = window['scene_' + starScene] || {};
    fallingStarScript = fallingStarScript.animscript || fallingStarScript;

    // for test
    /* $.each(fallingStarScript.groups, function(i, v){
        if (fallingStarScript.groups[i].items) {
            $.each(fallingStarScript.groups[i].items, function(i2, v2){
                fallingStarScript.groups[i].items[i2].loop = true;
                //fallingStarScript.groups[i].items[i2].randomizeStart = {translate:{x:[true,-10000,10000],y:[true,-10000,10000]}};
            });
        }
    }); */

    const fallingCnf = $fallingAnimationContainer.data('cnf') || {};
    const parseCnfNumber = function (value) {
        value = parseInt(value, 10);
        return isNaN(value) ? 0 : value;
    };
    const containerEl = $fallingAnimationContainer.get(0);
    const containerRect = containerEl ? containerEl.getBoundingClientRect() : {
        top: 0,
        height: 0
    };
    const half = parseCnfNumber(fallingCnf.nofly) / 2;
    const screenOffsetTop = parseCnfNumber(fallingCnf.offtop);
    const screenOffsetBottom = parseCnfNumber(fallingCnf.offbot);
    const desiredTop = parseCnfNumber(fallingCnf.yneg);
    const desiredBottom = parseCnfNumber(fallingCnf.ypos);
    const viewportHeight = window.innerHeight || $(window).height() || 0;
    const viewportTop = Math.min(screenOffsetTop, viewportHeight);
    const viewportBottom = Math.max(viewportTop, viewportHeight - screenOffsetBottom);
    const containerCenter = containerRect.top + (containerRect.height / 2);
    const maxTop = Math.max(0, containerCenter - viewportTop);
    const maxBottom = Math.max(0, viewportBottom - containerCenter);
    var top = Math.max(0, Math.min(desiredTop, maxTop)) - half;
    var bottom = Math.max(0, Math.min(desiredBottom, maxBottom)) - half;
    const rnd = getRndInteger(0, Math.max(0, top + bottom));
    var offset = 0;
    if (top > rnd) {
        offset = 0 - rnd - half;
    } else {
        offset = rnd - top + half;
    }

    if (cbbefore) {
        cbbefore(fallingCnf, offset, top + half, bottom + half);
    }

    var $animationField = $('<div class="fallingAnimation animationFld abs" data-origwidth="' + $fallingAnimationContainer.data('origwidth') + '" data-origheight="' + $fallingAnimationContainer.data('origheight') + '"></div>');
    $fallingAnimationContainer.append($animationField);
    $animationField.css({
        top: offset + 'px'
    });

    if (runconfs) {
        const delays = [
            parseInt(fallingCnf.d),
            getRndInteger(0, parseInt(fallingCnf.d2))
        ];
        $('.cnmGo2Status').text(delays.join(' + '));

        if (delays[0]) {
            await sleep(delays[0]);
        }
        if (delays[1]) {
            await sleep(delays[1]);
        }
    }

    const fallingStar = new modAnimationRun({
        autoplay: true,
        prepare: true,
        groups: fallingStarScript.groups,
        animations: fallingStarScript.animations,

        animationContainer: $animationField.get(0)
    }, $('.fallingAnimationContainer').get(0));

    fallingStar.onStop = function () {
        if ($animationField) {
            $animationField.remove();
        }
        if (cbstop) {
            cbstop();
        }
        if (runconfs && cht2ItemId) {
            var sid = 0, id = 0;
            $('.floatingChat').each(function () {
                sid = $(this).closest('[data-sid]').data('sid');
                id = $(this).closest('[data-id]').data('id');
            });
            ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: 'starFell',
                    sid: sid,
                    id: id,
                    cht2ItemId: cht2ItemId
                },
                dataType: 'json'
            });
        }
    };
}

function showRandWelcome(randWelcome) {
    var $el = $('<div class="randWelcome"></div>').css({
        opacity: 0
    }).append($('<div class="inner"></div>').html(randWelcome)).appendTo('body');

    $el.animate({
        opacity: 1
    }, 500, function () {
        $('.cht2fld').css('display', '');

        $el.find('a').on('mousedown', function (event) {
            event.stopPropagation();
        });

        $('body').one('mousedown', function () {
            $el.animate({
                opacity: 0
            }, 500, function () {
                $el.remove();
            });
        });
    });
}

function disableClicking(disabled, el, remove) {
    var $el;

    if (el) {
        $el = $(el);
    } else {
        $el = $('<div class="disableClicking"></div>').appendTo('body');
    }

    $el.toggleClass('disabled', disabled);

    if (!disabled && remove) {
        $el.remove();
        return null;
    }

    $el.on('click', function (event) {
        if ($(this).hasClass('disabled')) {
            event.preventDefault();
            event.stopPropagation();
        }
    });

    return $el.get(0);
}

function addStatCounterGlobal(connectSID, connectIID, cb) {
    const id = 'global';
    autoSyncer.setGlobal('connectSID', connectSID);
    autoSyncer.setGlobal('connectIID', connectIID);

    autoSyncer.add('stat-counter-global', id, {
        global: 1
    }, function (itemData) {
        cb(itemData);
        return false;
    });
}


function showConnect(delay) {
    if (delay) {
        setTimeout(function () { showConnect(); }, delay);
        return;
    }
    $('.connectTx').removeClass('collapsed');
}


export function loadPageConnect() {
    const connectData = getJsonData('app-connect');
    var isConnected = VarMgr.get('isConnected', false);

    connectData.connectScript = getAnimScript(connectData.connectScript);
    connectData.starScript = getAnimScript(connectData.starScript);
    connectData.addsceneScript = getAnimScript(connectData.addsceneScript);
    connectData.miracleScript = getAnimScript(connectData.miracleScript);

    initConnectPage(isConnected, connectData);
}